import { Button, DrawerBody, DrawerHeader, Flex, Avatar, Text, Link } from '@chakra-ui/react'
// import { useMapCoreManager } from '../../../../contexts/MapCoreManager/Provider'
import { CITIZEN_PROFILE_EXTERNAL_ROUTES } from 'modules/CitizenProfile/constants/routes'
import { useMemo } from 'react'

export default function UnifiedPersonDrawer() {
  //   const { selectedEntity } = useMapCoreManager()

  const goToCitizenProfile = useMemo(() => {
    return CITIZEN_PROFILE_EXTERNAL_ROUTES.CITIZEN_PROFILE.replace('[citizenSlug]', 'aaa' as string)
  }, [])

  return (
    <>
      <DrawerHeader>Pessoa unificada</DrawerHeader>
      <DrawerBody p={0}>
        <Flex>
          <Flex p={4} gap={4} bg="bgContent" w="full" borderBottom={'1px solid'} borderColor="borderColor">
            <Flex border="2px solid" borderColor={'primary'} rounded={'full'}>
              <Avatar
                size={'xl'}
                src="https://impacto-prd-impacto-publicfiles-protected.s3.sa-east-1.amazonaws.com/public//person/1000000003/public-file/avatar/ATAFE7v0kmN3EsrwOz83LIl2mTLjk.avatar"
              />
            </Flex>
            <Flex flexDir={'column'} justifyContent={'space-around'}>
              <Text fontSize={'xl'}>Arthur de Melo Gerônimo</Text>
              <Link href={goToCitizenProfile} target="_blank" w="100%">
                <Button tabIndex={-1} w="100%">
                  Acessar perfil integrado
                </Button>
              </Link>
            </Flex>
          </Flex>
        </Flex>
      </DrawerBody>
    </>
  )
}
